// Public landing / marketing page — route /#/start. Rehosted from the legacy
// frontend as the unauthenticated fallback. The legacy "Sign up here" call to action
// (which pointed at the retired Stripe self-service onboarding /#/select-plan) is
// intentionally dropped: onboarding is now handled manually from the admin panel.
import StaticPageLayout from './StaticPageLayout'
import { t } from '../../i18n'

const Landing = () => {
  return (
    <StaticPageLayout title={t.landingHeroTitle} wide>
      <p className="cf-subtitle">{t.landingHeroSubtitle}</p>

      <div className="cf-landing-cards">
        <div className="cf-landing-card">
          <h3>{t.landingCard1Title}</h3>
          <p>{t.landingCard1Body}</p>
        </div>
        <div className="cf-landing-card">
          <h3>{t.landingCard2Title}</h3>
          <p>{t.landingCard2Body}</p>
        </div>
        <div className="cf-landing-card">
          <h3>{t.landingCard3Title}</h3>
          <p>{t.landingCard3Body}</p>
        </div>
      </div>

      <p className="cf-landing-footer">
        <a href="#/privacy-policy">{t.privacyPolicyTitle}</a>
        <span aria-hidden="true"> · </span>
        <a href="#/contact">{t.contactTitle}</a>
      </p>
    </StaticPageLayout>
  )
}

export default Landing
